import UmlCompositeShape from './UmlCompositeShape';

// children[] = UmlClassShape[] (evt. geneste UmlPackageShape).
class UmlPackageShape extends UmlCompositeShape {
  constructor(id, x, y, w, h, name) {
    super(id, x, y, w, h);
    this.name = name;
    this.kind = 'package'; // discriminant voor UmlShapeSerializer.fromPlainShape (JSON heeft geen class-info)
  }
}

export default UmlPackageShape;
